// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RunsTable_checkbox__cmGRW","checkedCheckbox":"RunsTable_checkedCheckbox__3fGNk","sortingBox":"RunsTable_sortingBox__95ymK"};